
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/castlepedia-pro",
      function () {
        return require("private-next-pages/castlepedia-pro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/castlepedia-pro"])
      });
    }
  